import { useEffect, useState } from 'react';
import { RangeSelector } from '../RangeSelector';
import { AddRowButtonComponent } from '../utilsComponents/AddRowButtonComponent';
import { RangeSelectorShippingCost } from '../RangeSelectorShippingCost';
import SaveButtonComponent from '../utilsComponents/SaveButtonComponent';
import InformationIcon from 'components/utils/iconComponents/InformationIcon';

const ShippingMargins = ({
  ranges,
  rangesKg,
  setRangesKg,
  setRanges,
  onSaveSettings,
  onValidatedChanged,
  isValidated,
  onValidatedChangedKg,
  isValidatedKg,
  loading,
  setFee,
  fee,
  amazonPriceTax,
  setAmazonPriceTax,
  setBasePrice,
  basePrice,
  usatax,
  setUsatax,
  mlCommission,
  setMlCommission,
  mlEarnings,
  setMlEarnings,
}) => {
  const [addRowIconTitle, setAddRowIconTitle] = useState('Agregar fila');

  useEffect(() => {
    const hasEmptyRange = ranges
      .slice(0, -1)
      .some((range, idx) => +range.max !== +ranges[idx + 1].min);
    onValidatedChanged(!hasEmptyRange);
  }, [ranges]);

  useEffect(() => {
    const hasEmptyRangeKg = rangesKg
      .slice(0, -1)
      .some((range, idx) => +range.max !== +rangesKg[idx + 1].min);
    onValidatedChangedKg(!hasEmptyRangeKg);
  }, [rangesKg]);

  const onAddRow = (min, max, position) => {
    const newRanges = [...ranges];
    newRanges.splice(position + 1, 0, { min, max, percentage: 0 });
    setRanges(newRanges);
  };

  const onRemoveRow = (position) => {
    const newRanges = [...ranges];
    newRanges.splice(position, 1);
    setRanges(newRanges);
  };

  const onMinChange = (idx, newValue) => {
    const newRanges = [...ranges];
    newRanges[idx] = {
      ...newRanges[idx],
      min: newValue,
    };
    setRanges(newRanges);
  };

  const onMaxChange = (idx, newValue) => {
    const newRanges = [...ranges];
    newRanges[idx] = {
      ...newRanges[idx],
      max: newValue,
    };
    setRanges(newRanges);
  };

  const onPercentageChange = (idx, newValue) => {
    const newRanges = [...ranges];
    newRanges[idx] = {
      ...newRanges[idx],
      percentage: +newValue,
    };
    setRanges(newRanges);
  };

  // Funciones de costo de envio
  const onAddRowShippingCost = (min, max, position) => {
    const newRanges = [...rangesKg];
    newRanges.splice(position + 1, 0, {
      min,
      max,
      price: 0,
      coin: '0',
    });
    setRangesKg(newRanges);
  };

  const onRemoveRowShippingCost = (position) => {
    const newRanges = [...rangesKg];
    newRanges.splice(position, 1);
    setRangesKg(newRanges);
  };

  const onMinChangeShippingCost = (idx, newValue) => {
    const newRanges = [...rangesKg];
    newRanges[idx] = {
      ...newRanges[idx],
      min: newValue,
    };
    setRangesKg(newRanges);
  };

  const onMaxChangeShippingCost = (idx, newValue) => {
    const newRanges = [...rangesKg];
    newRanges[idx] = {
      ...newRanges[idx],
      max: newValue,
    };
    setRangesKg(newRanges);
  };

  const onPercentageChangeShippingCost = (idx, newValue) => {
    const newRanges = [...rangesKg];
    newRanges[idx] = {
      ...newRanges[idx],
      price: +newValue,
    };
    setRangesKg(newRanges);
  };

  const onCoinChangeShippingCost = (idx, newValue) => {
    const newRanges = [...rangesKg];
    newRanges[idx] = {
      ...newRanges[idx],
      coin: +newValue,
    };
    setRangesKg(newRanges);
  };
  return (
    <div className='flex flex-col justify-between h-full'>
      <div className='w-full flex max-h-[580px] h-[85%]'>
        <div className='w-[30%] border-2 border-r-primary-100 border-x-white border-y-white overflow-auto'>
          <div className='grid grid-cols-2 gap-4 mr-4 mb-8'>
            <div>
              <label
                htmlFor='fee'
                className='ml-1 block text-sm font-medium leading-6 text-gray-700'
              >
                % cuota del giro
              </label>
            </div>
            <div>
              <label
                htmlFor='meliShipping'
                className='block text-sm font-medium leading-6 text-gray-700'
              >
                % Impuesto USA
              </label>
            </div>
            <div className='ml-1'>
              <input
                name='fee'
                id='fee'
                type='number'
                min={0}
                max={100}
                maxLength={3}
                size={8}
                className='block w-full rounded-md border-0 border-gray-300 py-1.5 text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-2'
                value={fee}
                onChange={(e) => setFee(e.target.value)}
              />
            </div>
            <div>
              <input
                name='usatax'
                id='usatax'
                type='number'
                min={0}
                max={100}
                maxLength={3}
                size={8}
                className='block w-full rounded-md border-0 border-gray-300 py-1.5 text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-2'
                value={usatax}
                onChange={(e) => setUsatax(e.target.value)}
              />
            </div>
          </div>
          <div className='grid grid-cols-1 gap-2 mt-4'>
            <div>
              <label
                htmlFor='amazonPriceTax'
                className='ml-1 block text-sm font-medium leading-6 text-gray-700'
              >
                Aplicar porcentaje a los costos de origen para tributar
                impuestos
              </label>
            </div>
            <div className='w-full flex mr-4 mb-8'>
              <div className='w-[50%] ml-1'>
                <select
                  id='amazonPriceTax'
                  name='amazonPriceTax'
                  className='pl-2 bg-white block w-full h-full rounded-md border-0 py-1.5 text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6'
                  value={amazonPriceTax.option}
                  onChange={(e) =>
                    setAmazonPriceTax({
                      ...amazonPriceTax,
                      option: e.target.value,
                    })
                  }
                >
                  <option value='0'>Precio producto + costo envio</option>
                  <option value='1'>Precio producto sin costo envio</option>
                </select>
              </div>
              <div className='w-[23%] px-2'>
                <span className='w-full h-full bg-primary-100 text-primary-700 rounded-md items-center justify-center flex'>
                  %
                </span>
              </div>
              <div className='w-[24%] mr-4'>
                <input
                  type='number'
                  name='amazonPricePercentage'
                  id='amazonPricePercentage'
                  min={0}
                  max={100}
                  maxLength={3}
                  size={4}
                  className='block w-full rounded-md border-0 border-gray-300 py-1.5 text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-2'
                  value={amazonPriceTax.percentage}
                  onChange={(e) =>
                    setAmazonPriceTax({
                      ...amazonPriceTax,
                      percentage: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>
          <div className='grid grid-cols-1 gap-2 mt-4 mb-8'>
            <div className='w-full flex mr-4'>
              <div className='w-[50%] ml-1 flex items-center'>
                Comisi&oacute;n de ML
              </div>
              <div className='w-[23%] px-2'>
                <span className='w-full h-full bg-primary-100 text-primary-700 rounded-md items-center justify-center flex'>
                  %
                </span>
              </div>
              <div className='w-[24%] mr-4'>
                <input
                  type='number'
                  name='mlCommission'
                  id='mlCommission'
                  min={0}
                  max={100}
                  maxLength={3}
                  size={4}
                  className='block w-full rounded-md border-0 border-gray-300 py-1.5 text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-2'
                  value={mlCommission}
                  onChange={(e) => setMlCommission(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className='grid grid-cols-1 gap-2 mt-4'>
            <div className='w-full flex mr-4'>
              <div className='w-[50%] ml-1 flex items-center'>
                Ganancia de producto
              </div>
              <div className='w-[23%] px-2'>
                <span className='w-full h-full bg-primary-100 text-primary-700 rounded-md items-center justify-center flex'>
                  %
                </span>
              </div>
              <div className='w-[24%] mr-4'>
                <input
                  type='number'
                  name='mlEarnings'
                  id='mlEarnings'
                  min={0}
                  max={100}
                  maxLength={3}
                  size={4}
                  className='block w-full rounded-md border-0 border-gray-300 py-1.5 text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-2'
                  value={mlEarnings}
                  onChange={(e) => setMlEarnings(e.target.value)}
                />
              </div>
            </div>
          </div>
          {/* <div className='mb-2'>
            <span>
              <h2>% ganancia sobre el valor del producto en Amazon</h2>
            </span>
          </div>
          {ranges.map((range, idx) => (
            <>
              <RangeSelector
                min={+range.min}
                max={+range.max}
                percentage={range.percentage}
                idx={idx}
                ranges={ranges}
                onMinChange={(newValue) => onMinChange(idx, newValue)}
                onMaxChange={(newValue) => onMaxChange(idx, newValue)}
                onPercentageChange={(newValue) =>
                  onPercentageChange(idx, newValue)
                }
                onRemoveRow={onRemoveRow}
              />
              {idx < ranges.length - 1 &&
                +range.max !== +ranges[idx + 1].min && (
                  <AddRowButtonComponent
                    position={idx}
                    ranges={ranges}
                    onAddRow={onAddRow}
                    title={addRowIconTitle}
                  />
                )}
            </>
          ))} */}
        </div>
        <div className='w-[70%] ml-4 overflow-auto'>
          <div className='mb-2'>
            <span>
              <h2>Costo del envio por Kg del envio del courrier</h2>
            </span>
          </div>
          <div className='grid grid-flow-col grid-cols-8 gap-2 mb-4'>
            <div className='w-full flex justify-center col-span-3'>
              <span className='w-[97%] h-full bg-primary-100 text-primary-700 rounded-md items-center justify-center flex'>
                Precio base
              </span>
            </div>
            <div className='w-full flex justify-center'>
              <input
                type='number'
                name='basePrice'
                id='basePrice'
                onChange={(e) => setBasePrice(e.target.value)}
                className='block rounded-md border-0 border-gray-300 py-1.5 text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-2 w-[80%]'
                maxLength='3'
                size='4'
                value={basePrice}
              />
            </div>
            <div className='w-full flex items-center'>
              <span className='flex justify-start cursor-pointer h-[25px] ml-2'>
                <InformationIcon
                  title='Este costo comprende enpaque y manejo y tasa postal'
                  color='#6941C6'
                />
              </span>
            </div>
          </div>
          {rangesKg.map((rangeKg, idx) => (
            <>
              <RangeSelectorShippingCost
                min={+rangeKg.min}
                max={+rangeKg.max}
                price={rangeKg.price}
                coin={rangeKg.coin}
                idx={idx}
                ranges={rangesKg}
                onMinChange={(newValue) =>
                  onMinChangeShippingCost(idx, newValue)
                }
                onMaxChange={(newValue) =>
                  onMaxChangeShippingCost(idx, newValue)
                }
                onPercentageChange={(newValue) =>
                  onPercentageChangeShippingCost(idx, newValue)
                }
                onCoinChange={(newValue) =>
                  onCoinChangeShippingCost(idx, newValue)
                }
                onRemoveRow={onRemoveRowShippingCost}
              />
              {idx < rangesKg.length - 1 &&
                +rangeKg.max !== +rangesKg[idx + 1].min && (
                  <AddRowButtonComponent
                    position={idx}
                    ranges={rangesKg}
                    onAddRow={onAddRowShippingCost}
                    title={addRowIconTitle}
                  />
                )}
            </>
          ))}
        </div>
      </div>
      <div className='w-full flex mt-2 justify-end'>
        <SaveButtonComponent
          onSaveSettings={onSaveSettings}
          isValidated={isValidated}
          isValidatedKg={isValidatedKg}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default ShippingMargins;
